import { set } from "date-fns";
import { useSearchParams } from "react-router-dom";

export const useGetParams = (
  keys: string[],
  defaults: Record<string, string> = {},
): string => {
  // Initialize the search parameters state
  const [searchParams] = useSearchParams();
  const queryParams = new URLSearchParams();

  // First, add default values for keys not present in search params
  Object.entries(defaults).forEach(([key, defaultValue]) => {
    if (!searchParams.get(key)) {
      queryParams.set(key, defaultValue);
    }
  });

  keys.forEach((key) => {
    if (key === "fortnight" || key === "dateRange") {
      const startEndDate = searchParams.getAll(
        key === "fortnight" ? "fortnight" : "dateRange",
      );

      // Special handling for 'fortnight' key
      if (startEndDate.length === 2) {
        const startDate = set(new Date(startEndDate[0]), {
          hours: 0,
          minutes: 0,
          seconds: 0,
        }).toISOString();

        const endDate = set(new Date(startEndDate[1]), {
          hours: 23,
          minutes: 59,
          seconds: 59,
        }).toISOString();
        queryParams.set("startDate", startDate);
        queryParams.set("endDate", endDate);
      }
    } else {
      if (searchParams.get(key)) {
        const value = searchParams.get(key) || "";
        queryParams.set(key, value);
      }
    }
  });

  return queryParams.toString() ? `?${queryParams.toString()}` : "";
};
